// Copyright (c) 2016 Deere & Company

import BusyCounter, {getDefaultState as getBusyCounterDefaultState} from '../../../shared/state/busy-counter';
import Claim, {getDefaultState as getClaimDefaultState} from '@deere/cps-it.warranty-model-factory/lib/claim-attachment';
import ConfirmationModal, {getDefaultState as getConfirmationModalDefaultState} from '../../shared/state/confirmation-modal';
import CreateClaimModalType, {getDefaultState as getCreateClaimModalTypeDefaultState} from '../../../shared/state/create-claim-modal';
import FormValidation, {getDefaultState as getDefaultFormValidationState} from './form-validation';
import KeyValuePairCollection, {getDefaultState as getDefaultKeyValueCollection} from '@deere/cps-it.warranty-model-factory/lib/key-value-pair-collection';
import t from 'tcomb';

const AttachmentClaim = t.struct({
    application: KeyValuePairCollection,
    busyCounter: BusyCounter,
    claim: Claim,
    confirmationModal: ConfirmationModal,
    createClaimModal: CreateClaimModalType,
    failureModes: KeyValuePairCollection,
    formValidation: FormValidation,
    installedBy: KeyValuePairCollection,
    isActionButtonDisabled: t.Boolean,
    isCopied: t.Boolean,
    isEditable: t.Boolean,
    isStickyHeaderVisible: t.Boolean,
    isValidClaim: t.Boolean,
    temporaryObjectKey: t.String
}, 'AttachmentClaim');

export const getDefaultState = () =>
    new AttachmentClaim({
        application: getDefaultKeyValueCollection(),
        busyCounter: getBusyCounterDefaultState(),
        claim: getClaimDefaultState(),
        confirmationModal: getConfirmationModalDefaultState(),
        createClaimModal: getCreateClaimModalTypeDefaultState(),
        failureModes: getDefaultKeyValueCollection(),
        formValidation: getDefaultFormValidationState(),
        installedBy: getDefaultKeyValueCollection(),
        isActionButtonDisabled: false,
        isCopied: false,
        isEditable: true,
        isStickyHeaderVisible: false,
        isValidClaim: false,
        temporaryObjectKey: ''
    });

export default AttachmentClaim;



// WEBPACK FOOTER //
// ./src/claim/attachment/state/index.js